import { FC, Fragment } from 'react';
import { DEFAULT_SECTION } from './ManageCustomPage';
import { ICustomPageSection, SectionType } from '../../../models';
import { getRandomNegativeNumber } from '../../../helpers';
import { Add, Clear } from '@mui/icons-material';
import { Grid, Button, IconButton, TextField, Typography } from '@mui/material';

interface ILinkBlockSection {
  setSections: (val: ICustomPageSection[]) => void;
  parentSections: ICustomPageSection[];
  parentIndex: number;
  sections: ICustomPageSection[];
  index: number;
}

export const LinkBlockSection: FC<ILinkBlockSection> = ({ index, sections, parentSections, setSections, parentIndex }) => {
  // use this to deeply copy sections so we don't modify the original array
  const copy: ICustomPageSection[] = JSON.parse(JSON.stringify(parentSections));
  return (
    <div>
      <Typography variant="h6">Link Block Section</Typography>
      <Typography variant="caption" component="p" sx={{ marginBottom: '1rem' }}>
        Add link headings along with button text and link urls
      </Typography>
      <Grid container spacing={1}>
        {sections.map((item, subSectionIndex) => {
          const currentLinkBlock = copy[parentIndex].sections[index].sections[subSectionIndex];
          return (
            <Fragment key={`${subSectionIndex}`}>
              <Grid item xs={12} md={3}>
                <TextField
                  size="small"
                  label="Link Title"
                  autoComplete="nope"
                  variant="outlined"
                  value={item.name}
                  fullWidth
                  sx={{ marginBottom: '0.75rem' }}
                  onChange={e => {
                    currentLinkBlock.name = e.target.value;
                    setSections(copy);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size="small"
                  label="Link Text"
                  autoComplete="nope"
                  variant="outlined"
                  value={item.linkText}
                  required
                  fullWidth
                  sx={{ marginBottom: '0.75rem' }}
                  error={!currentLinkBlock.linkText ? true : false}
                  helperText={!currentLinkBlock.linkText && 'Required'}
                  onChange={e => {
                    currentLinkBlock.linkText = e.target.value;
                    setSections(copy);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <TextField
                  size="small"
                  label="Link URL"
                  autoComplete="nope"
                  variant="outlined"
                  value={item.linkUrl}
                  required
                  fullWidth
                  sx={{ marginBottom: '0.75rem' }}
                  onChange={e => {
                    currentLinkBlock.linkUrl = e.target.value;
                    setSections(copy);
                  }}
                  error={
                    // not a valid relative route
                    !currentLinkBlock.linkUrl?.startsWith('http') ||
                    // required field for a sub route link
                    !currentLinkBlock.linkUrl ||
                    // can't contain white space
                    currentLinkBlock?.linkUrl?.indexOf(' ') >= 0
                      ? true
                      : false
                  }
                  helperText={
                    !currentLinkBlock.linkUrl
                      ? 'Required'
                      : !currentLinkBlock.linkUrl?.startsWith('http')
                      ? 'Must start with http'
                      : currentLinkBlock?.linkUrl?.indexOf(' ') >= 0
                      ? 'Must not contain white space'
                      : ''
                  }
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <IconButton
                  color="error"
                  title="Remove"
                  sx={{ p: '2px' }}
                  onClick={() => {
                    const result = window.confirm('Are you sure you want to remove this link item?');
                    if (result) {
                      const newItems = copy[parentIndex].sections[index].sections.filter(l => l.customPageSectionId !== item.customPageSectionId);
                      copy[parentIndex].sections[index].sections = newItems;
                      setSections(copy);
                    }
                  }}
                >
                  <Clear />
                </IconButton>
              </Grid>
            </Fragment>
          );
        })}
      </Grid>

      <Button
        color="secondary"
        startIcon={<Add />}
        sx={{ fontSize: '14px', padding: 0 }}
        onClick={() => {
          const randomNumber = getRandomNegativeNumber();
          copy[parentIndex].sections[index].sections.push({
            ...DEFAULT_SECTION,
            name: '',
            customPageSectionId: randomNumber,
            type: SectionType.BUTTON_LINK,
            sortOrder: copy[parentIndex].sections[index].sections.length + 1
          });
          setSections(copy);
        }}
      >
        Add Link Item
      </Button>
    </div>
  );
};
